import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  doc,
  getDoc
} from "firebase/firestore";
import { db } from '../../../firebase';
import Navbar from '../../main/Navbar2';
import EmptyList from '../components/common/EmptyList';
import userController from '../../../controllers/usercontroller';
import './styles.css';

const Blog = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [post, setPost] = useState({
    id: '',
    title : '',
    author: '',
    content : '',
    img: '',
    createdAt: ''
  });
  const navigate = useNavigate()

  let [firstRender, setFirstRender] = useState({
    firstRender: true,
  });

  const getPostDetails = async () => {
      try {
          const userRef = doc(db, "posts", id);
          const userSnap = await getDoc(userRef);
          
          if(userSnap.exists()){
          return userSnap.data();
          }
          else{
          return null;
          }
      } catch (error) {
          if(error.toString().includes("offline")){
              window.alert('Pas de connexion internet')
          }
          else{
              window.alert(error)
          }
      }
  };

  const [user, setUser] = useState({
    displayName: ''
  });

  const getUserDetails = async (uid) => {
    await userController.getUserDetails(uid, 'users').then((value)=>{
      if(value != null){
          setUser(value);
      }
    });
  };

  useEffect(() => {
    // getting user details
    if(firstRender){
        getPostDetails().then(data => {
            if(data != null){
                //user = data;
                setPost(data);
                setFirstRender(false);

                if(data.author){
                  getUserDetails(data.author).then(data => {
                    if(data != null){
                        //user = data;
                        setUser(data);
                    }
                  });
                }
            }
        });
    }
  }, []);

  const handleReturn = async (id) => {
    navigate(-1);
  }

  return (
    <>
              <Navbar/>
              <input type="button" className="btn btn-primary m-3" value={t('return')} onClick={handleReturn}/>
        {
          post ?(
            <div className='w-75 m-4'>
              <div className="top">
                <h1>{post.title}</h1>
              </div>
              <div className="bottom">
                <div className="left">
                  <img src={post.img} alt='' className='img-fluid' />
                </div>
                <div className="right">
                  <p className='blog-desc'>{post.content}</p>
                  <br />
                  <h6><span className='pub_name'>publié par</span> {user.displayName}</h6>
                </div>
              </div>
            </div>
          )  : (
            <EmptyList />
          )
        }
    </>
  );
};

export default Blog;
